import { MARKET_REQUESTS_UPDATED, useMarketRequestsAdminService } from 'nekst-api';
import { Cell, FilterContext, List, TextField, TextLink, useShowContextRequired } from 'ui-builder';
import { GridLayout } from 'features/nekst-widgets';
import React from 'react';
import RequestStatusField from '../../../markets/requests/RequestStatusField';
import useSettingsNavigator from '../../../settingsNavigator';

function MarketRequestLink() {
  const settingsNavigator = useSettingsNavigator();

  const { data } = useShowContextRequired();

  return (
    <TextLink
      href={settingsNavigator.getAdminMarketRequestLink(data.id)}
    >
      {data.name}
    </TextLink>
  );
}

export default function MarketsRequestsList() {
  const marketRequestsAdminService = useMarketRequestsAdminService();

  return (
    <FilterContext>
      <List
        getDataFunc={marketRequestsAdminService.getAllMarketRequests}
        updateOnEvents={[MARKET_REQUESTS_UPDATED]}
      >
        <GridLayout>
          <Cell label="Name">
            <MarketRequestLink />
          </Cell>
          <Cell label="Status">
            <RequestStatusField />
          </Cell>
          <Cell label="Created By">
            <TextField source="_createdBy.name.fullName" />
            {' ('}
            <TextField source="_createdBy.primaryEmail" />
            {')'}
          </Cell>
        </GridLayout>
      </List>
    </FilterContext>
  );
}
